import { CaseItem, Category } from '@/interfaces';
import { Badge } from '../badge';
import { Button } from '../button';
import { Typography, TypographyProps } from '../typography';
import { CloseLabel } from './closeLabel';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { customEvent } from '@/lib';
import AppRoutes from '@/const/routes';

interface Props extends CaseItem {
	className?: string;
	isDescription?: boolean;
	titleSize?: TypographyProps['type'];
	classNameButton?: string;
}

export const CaseCard: React.FC<Props> = ({
	id,
	title,
	category,
	status,
	className,
	titleSize = 'semibold-24',
	classNameButton,
	eligibility_criteria,
	isDescription = true,
}) => {
	const router = useRouter();

	const handleClick = () => {
		customEvent({
			action: 'view_cases_click',
			category: 'landing',
			label: 'View Cases',
			value: 'View Cases',
			callback: () =>
				router.pathname.includes(AppRoutes.CLIENTAPP)
					? router.push(`${AppRoutes.CLIENTAPP_ALL_CASES}/${id}`)
					: router.push(`/cases/${id}`),
		});
	};

	return (
		<div
			className={clsx(
				'rounded-3xl flex flex-col justify-start gap-5 py-10 px-8 hover:shadow-md',
				status === 'Closed to new clients'
					? 'bg-bg-disabled border border-[#0D061614]'
					: 'bg-white',
				className
			)}
		>
			<div className="flex gap-2 items-center justify-between">
				<Badge type={category as Category} />
				{status === 'Closed to new clients' && <CloseLabel label={status} />}
			</div>
			<Typography type={titleSize} text={title} />

			{isDescription && (
				<>
					<Typography
						type="regular-16"
						text="Eligibility Criteria: "
						className="opacity-60 "
					/>
					<div
						dangerouslySetInnerHTML={{ __html: eligibility_criteria ?? '' }}
						className={clsx('text-base text-black opacity-60 line-clamp-3')}
					/>
				</>
			)}
			<div className="flex-1 flex items-end">
				<Button
					decoration="line-primary"
					size="small"
					className={`!w-[133px] !px-[23px] !h-12 bg-white ${classNameButton}`}
					onClick={handleClick}
				>
					View Case
				</Button>
			</div>
		</div>
	);
};
